import { useDispatch, useSelector } from 'react-redux';
import { EditableQuestion } from '../../../../../../../types';
import { setQuestions } from '../../../../../../../../../redux/questionnaire/actions';
import { selectQuestions } from '../../../../../../../../../redux/questionnaire/selectors';
import { useEditing } from '../../../../QuestionContainer/hooks/useEditing';
import { withoutClearedDefaultToggle } from '../../StructuredInputEditor/utils';

export const useSaveQuestion = (question: EditableQuestion) => {
  const questions = useSelector(selectQuestions);
  const { cancelEditing } = useEditing(question);
  const dispatch = useDispatch();

  const handleSaveQuestion = (updatedQuestion: EditableQuestion) => {
    // Form values carry a cleared default_toggle as an empty string; a saved question
    // should simply not have the field.
    const question = withoutClearedDefaultToggle(updatedQuestion);

    dispatch(setQuestions(updateQuestionInArray(questions, question)));
    cancelEditing();
  };

  return handleSaveQuestion;
};

const updateQuestionInArray = (questions: EditableQuestion[], updatedQuestion: EditableQuestion) => {
  return questions.map(question => (updatedQuestion._id === question._id ? updatedQuestion : question));
};
